import { Organization } from '@acies/domain';
import { SessionStorageService } from '@shared/services/storage.service';
import { UserService } from '@shared/services/user.service';
import { Observable, of, switchMap } from 'rxjs';
import { FeatureFlagsAdminModel } from '../model/model';
import AccessService from '../services/access.service';

export class AccessController {
	#accessService: AccessService;
	#model: FeatureFlagsAdminModel;
	public constructor(sessionStorageService: SessionStorageService, userService: UserService, model: FeatureFlagsAdminModel) {
		this.#accessService = new AccessService(sessionStorageService, userService);
		this.#model = model;
	}

	/** Ask the Access Service to get data and return a success / failed boolean. */
	public loadAccess(): Observable<boolean> {
		return this.#accessService.loadAccess().pipe(
			switchMap((value) => {
				if (value) {
					this.#model.organizations = value.organizations.sort(this.#sortOrganizationByName);
					this.#updateAccountsMap(value.organizations);
					return of(true);
				}
				return of(false);
			}),
		);
	}

	#sortOrganizationByName(a: Organization, b: Organization): -1 | 1 {
		if (a.name < b.name) {
			return -1;
		}
		return 1;
	}

	/** Update the accountsMap we are going to use later when creating Variants. */
	#updateAccountsMap(organizations: Organization[]): void {
		for (const organization of organizations) {
			for (const account of organization.accounts) {
				this.#model.accountsMap.set(account.id, account);
			}
		}
	}
}
